import TierAlertError from "@/Layouts/components/Tiers/TierAlertError";
import TierRows from "@/Layouts/components/Tiers/TierRows";
import { Collapse, Grid, Stack } from "@mui/material";
import { FC } from "react";
import { TransitionGroup } from "react-transition-group";
import MatrixRow from "./MatrixRow";
import { IBonusTier } from "./types";

interface MatrixTiersProps {
	title?: string;
	titleTooltip?: string;
	readOnly?: boolean;
	tiers?: IBonusTier[];
	disableAddTier?: boolean;
	disableDeleteTier?: boolean;
	rowInputErrors?: any[];
	bonusInputErrors?: any[];
	errorMessages?: string[];
	minimumColumns?: number;
	handleAddTier?: () => void;
	handleDeleteTier?: () => void;
	handleUpdateInputType?: (...args: any[]) => void;
	handleUpdateValue?: (...args: any[]) => void;
	position?: string;
}

const MatrixTiers: FC<MatrixTiersProps> = (props) => {
	const {
		title,
		titleTooltip,
		readOnly = false,
		tiers = [],
		disableAddTier = false,
		rowInputErrors = [],
		bonusInputErrors = [],
		errorMessages = [],
		handleAddTier = () => {},
		handleDeleteTier = () => {},
		handleUpdateInputType = () => {},
		handleUpdateValue = () => {},
		position = "",
		disableDeleteTier = false,
	} = props;

	return (
		<Grid item xs={12} mt={1} minHeight={"250px"}>
			<TierRows
				showTitle
				title={title}
				titleProps={{
					className: "tiered-title",
					sx: { transform: "rotate(270deg)" },
					icon: {
						present: !!titleTooltip,
						text: titleTooltip,
					},
				}}
				sxTitlePropsContainer={{
					top: 180,
					left: -58,
				}}
				centerTitleAfterRow={3}
				deleteButtonText={"Remove Tier"}
				addButtonText={"Add Tier"}
				deleteButtonDisabled={readOnly || disableDeleteTier}
				addButtonDisabled={disableAddTier}
				spaces={{
					mainSection: 235,
					columns: 195,
					totalColumns: tiers?.[0]?.bonuses?.length || 1,
					totalRows: tiers?.length || 1,
					separation: 5.5,
				}}
				rowsAreaProps={{ ml: "35px" }}
				onClickDelete={handleDeleteTier}
				onClickAdd={handleAddTier}
			>
				<TransitionGroup>
					<Collapse>
						<Stack direction="column" rowGap={2}>
							{tiers?.map((tier: IBonusTier, index: number) => (
								<Grid key={`tier_row_${index}`} container item>
									<MatrixRow
										index={index}
										tier={tier}
										spaces={{
											mainSection: 235,
											columns: 195,
											totalColumns: tiers?.[0]?.bonuses?.length || 1,
											totalRows: tiers?.length || 1,
											separation: 5.5,
											reduction: 0,
										}}
										rowInputErrors={rowInputErrors}
										bonusInputErrors={bonusInputErrors}
										readOnly={readOnly}
										spacing={"12px"}
										sxCells={{ minWidth: "200px" }}
										position={position}
										onActionUpdate={handleUpdateValue}
										onChangeType={handleUpdateInputType}
									/>
								</Grid>
							))}
						</Stack>
					</Collapse>
				</TransitionGroup>

				{Boolean(errorMessages?.length) && (
					<Grid container direction="column" rowSpacing={0.2} mt={1} mb={1} alignItems="flex-start">
						{errorMessages.map((message, index) => {
							return <TierAlertError key={`local_error_${index}`} text={message} />;
						})}
					</Grid>
				)}
			</TierRows>
		</Grid>
	);
};

export default MatrixTiers;
